import * as React from "react";
import { useSelector } from "react-redux";
import { selectUserData, selectUserType } from "../../features/userSlice";
import { db } from "../../utils/firebase";
import NutritionCard from "../../Components/NutritionCard/NutritionCard";
import NutritionScreenHeader from "./NutritionScreenHeader";
import "./Nutrition.css"
import SearchIcon from "@material-ui/icons/Search";

import ClearIcon from "@material-ui/icons/Clear";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";

function ViewAllSavedNutrition(props) {
  const userData = useSelector(selectUserData);
  const [nutrition, setNutrition] = React.useState([]);
  const [search, setsearch] = React.useState("");
  const [SearchList, setSearchList] = React.useState(null);
  const [SearchLoading, SetSearhLoading] = React.useState(false);
  const [openSearch, setopenSearch] = React.useState(false);
  const userType = useSelector(selectUserType);

  const [sorting, setsorting] = React.useState("desc");
  const [showFilter, setShowFilter] = React.useState(false);

  document.addEventListener("mouseup", function (e) {
    if (showFilter) {
      setShowFilter(false);
    }
  });
  React.useEffect(() => {
    if (userData) {
      db.collection("CoachFood")
        .where("from_id", "==", userData?.id)
        .where("assignedTo_id", "==", "")
        .orderBy("timestamp", sorting)
        .onSnapshot((snapshot) => {
          setNutrition(
            snapshot.docs.map((doc) => ({
              id: doc.id,
              data: doc.data(),
            }))
          );
        });
    }
  }, [userData?.id, sorting, userType]);

  React.useEffect(() => {
    setSearchList(nutrition);
    // console.log(assignedMealplans);
  }, [nutrition]);

  React.useEffect(async () => {
    if (search?.length > 0) {
      const names = await nutrition?.filter((workout) => {
        return workout.data.nutrition.nutritionName
          .toLowerCase()
          .includes(search.toLowerCase());
      });

      setSearchList(names);
      SetSearhLoading(false);
    } else {
      setSearchList(nutrition);
      SetSearhLoading(false);
    }
  }, [search, nutrition]);

  const options = [
    { value: "asc", label: "Recent" },
    { value: "desc", label: "old" },
  ];

  return (
    <div className="createNutrition" id="assignworkout" style={{ minHeight: "99.7vh" }}>
      {props.headerflagnutview != "true" && <NutritionScreenHeader back="/nutrition" name="Saved Meal Plans"/>}
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
        onClick={() => {
          setopenSearch(true);
          setsearch("");
        }}
        id="inputtagg"
          style={{
            margin: 20,
            backgroundColor: "white",
            padding: 5,
            display: "flex",
            alignItems: "center",
            border: "1px solid black",
            width: "500px",
            borderRadius: 10,
          }}
        >
          <input
            value={search}
            style={{
              width: "100%",
              display: openSearch ? "block" : "none",

              fontSize: 20,
              outline: "none",
              border: "none",
            }}
            onChange={(e) => {
              setsearch(e.target.value);
            }}
          />
          {search?.length == 0 ? (
                <div
                onClick={() => {
                  setopenSearch(true);
                  setsearch("");
                }}
              >
            <SearchIcon
              style={{
                cursor:'pointer',
                width: 30,
                height: 30,
              }}
              
            />
            </div>
          ) : (
            <div
              onClick={() => {
                setsearch("");
              }}
            >
              <ClearIcon
                style={{
                  width: 30,
                  height: 30,
                  cursor:'pointer'

                }}
              />
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            position: "relative",
            width: "100px",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <div className="filter_icon">
            <img
              onClick={() => {
                setShowFilter(!showFilter);
              }}
              src="/assets/filter.png"
              width="35px"
              height="35px"
            />
          </div>
          <div
            className="filter"
            style={{
              position: "absolute",
              marginTop: 40,
              display: showFilter ? "block" : "none",
              border: "1px solid black",
              fontSize: 12,
              borderRadius: 10,
            }}
          >
            <div
              onClick={() => {
                setsorting("desc");
                setShowFilter(false);
              }}
              style={{
                padding: 10,
                borderBottom: "1px solid black",
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                backgroundColor:sorting == "desc" ? "var(--primarycolor)" : "white",

              }}
            >
              new to old
            </div>
            <div
              onClick={() => {
                setsorting("asc");
                setShowFilter(false);
              }}
              style={{
                padding: 10,
                backgroundColor: sorting == "asc" ? "var(--primarycolor)" : "white",

                borderBottomLeftRadius: 10,
                borderBottomRightRadius: 10,
              }}
            >
              old to new
            </div>
          </div>
        </div>
        {/* <div
          style={{
            width: 150,
            marginLeft: "auto",
          }}
        >
          <Dropdown
            options={options}
            placeholder="Order By"
            onChange={(s) => {
              setsorting(s.value);
            }}
          />
        </div> */}
      </div>
      {search.length > 0 && (
        <div
          style={{
            fontSize: 13,
            marginLeft: 20,
          }}
        >
          {SearchList?.length} search results loaded
        </div>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "center",
          width: "100%",
          marginLeft: "10px",
          marginRight: "10px",
          marginTop: "15px",
        }}
      >
        <div
          style={{
            width: "50%",
            marginTop: "20px",
            paddingLeft: "15px",
            paddingRight: "15px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {SearchList?.length > 0 ? (
            SearchList?.map((food, idx) => (
              <NutritionCard
              removecross = {props.removecross}
              variableclass = "variableclassthree"
                key={idx}
                nutrition={nutrition}
                food={food}
                idx={idx}
                navigation={"ViewAllNutrition"}
                type={true}
                isLongTerm={props?.isLongTerm}
                handleCloseNutrition={props?.handleCloseNutrition}
                setWeeks={props?.setWeeks}
                weeks={props?.weeks}
                selectedWeekNum={props?.selectedWeekNum}
                selectedDay={props?.selectedDay}
              />
            ))
          ) : (
            <h5
              style={{
                fontSize: "12px",
                backgroundColor: "#fff",
                width: "100%",
                paddingTop: "10px",
                paddingRight: "10px",
                textAlign: "center",
                borderRadius: "5px",
              }}
            >
              There are no saved nutrition for now
            </h5>
          )}
        </div>
      </div>
    </div>
  );
}

export default ViewAllSavedNutrition;
